import { render } from "./sub-navbar.vue?vue&type=template&id=2a55eeb6&scoped=true"
import script from "./sub-navbar.vue?vue&type=script&lang=ts"
export * from "./sub-navbar.vue?vue&type=script&lang=ts"

import "./sub-navbar.vue?vue&type=style&index=0&id=2a55eeb6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a55eeb6"

export default script